import CityService from './cityService';

export { CityService };
export default CityService;
